import { createFileRoute } from "@tanstack/react-router";
import { ConditionPageLayoutEs } from "@/components/ConditionPageLayoutEs";
import { esMigraines } from "@/pages/es/esConditionData4";
import { buildEsConditionHead } from "@/pages/es/esConditionShared";

export const Route = createFileRoute(
  "/es/migraines-treatment-coral-springs-fl",
)({
  head: () => buildEsConditionHead(esMigraines),
  component: RouteComponent,
});

function RouteComponent() {
  return <ConditionPageLayoutEs cfg={esMigraines} />;
}
